import React from "react"
import PropTypes from "prop-types"
import PortableText from "@sanity/block-content-to-react"
import serializers from "./serializers"
import styles from "./BlockContent.module.scss"
import useScrollAnimation from "../../hooks/useScrollAnimation"

function BlockContentWrapper(props) {
  const { blocks } = props

  useScrollAnimation()

  if (!blocks) {
    return null
  }

  return (
    <PortableText
      blocks={blocks}
      serializers={serializers}
      projectId="elrteb68"
      dataset="production"
      className={styles.wrapper}
    />
  )
}

BlockContentWrapper.propTypes = {
  blocks: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.object),
    PropTypes.string,
  ]),
  className: PropTypes.string,
}

export default BlockContentWrapper
